import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { Inject } from "@angular/core";

export interface GroupAttributes {
  hidden: boolean;
  islink: boolean;
  headerfields: boolean;
  hiddenonnew: boolean;
  hiddenonedit: boolean;
  onnew: boolean;
  onedit: boolean;
  recordtypeexist: boolean;
  object: string;
  linkrelativeurl: string;
  linkfield: string;
  sequence: number;
  lockedonedit:boolean;
  lockedonnew:boolean;
  // autofillsource:string;
}

@Component({
  selector: "app-groupattributes-dialog",
  templateUrl: "./groupattributes-dialog.component.html",
  styleUrls: ["./groupattributes-dialog.component.scss"],
})
export class GroupattributesDialogComponent implements OnInit {
  constructor(
    private dialogRef: MatDialogRef<GroupattributesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  @Output() groupFieldAttributesChanged: EventEmitter<GroupAttributes> =
    new EventEmitter<GroupAttributes>();
  // formdata: FormGroup;

  Groupfieldattributes: GroupAttributes = {
    hidden: false,
    islink: false,
    headerfields: false,
    hiddenonnew: false,
    hiddenonedit: false,
    onnew: true,
    onedit: true,
    recordtypeexist: false,
    object: "",
    linkrelativeurl: "",
    linkfield: "",
    sequence: 0,
    lockedonedit:false,
    lockedonnew:false,
    // autofillsource:""
  };
  // formdata;
  // linkfield;
  // linkrelativeurl;
  // object;
  // hidden;
  // islink;
  // recordtypeexist;

  ngOnInit() {
    console.log("data", this.data);

    if (this.data && this.data.Groupfieldattributes) {
      const attributes = this.data.Groupfieldattributes;
      this.Groupfieldattributes = {
        ...this.Groupfieldattributes,
        ...attributes,
        hiddenonnew:
          attributes.hiddenonnew != null ? attributes.hiddenonnew : false,
        hiddenonedit:
          attributes.hiddenonedit != null ? attributes.hiddenonedit : false,
        onnew: attributes.onnew != null ? attributes.onnew : true,
        onedit: attributes.onedit != null ? attributes.onedit : true,
      };
    }
  }

  // groupAttributes: GroupAttributes = {
  //   object: "",
  //   linkrelativeurl:"",
  //   linkfield:"",
  //   hidden: false,
  //   recordtypeexist: false,
  //   islink: false,
  // };

  onClickSubmit() {
    // console.log("data",data)
    var Groupfieldattributes = this.Groupfieldattributes;
    // this.dialogRef.close(data)
    console.log("data", this.Groupfieldattributes);

    this.dialogRef.close(this.Groupfieldattributes);

    this.groupFieldAttributesChanged.emit(Groupfieldattributes);

    console.log("groupfieldattributes", Groupfieldattributes);
  }
}
